var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" "+_vm._s(_vm.toast.notificationId)+" "),_c(_vm.allowedToasts(),{tag:"component",attrs:{"name":_vm.toast.params.senderName},nativeOn:{"click":function($event){return _vm.routerPush.apply(null, arguments)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }